import React from "react";
import { Card } from "antd";

import { useAppSelector } from "../../../hooks/reduxHooks";
import { getFirstName } from "../../../utils/helper.util";
import VideoModal from "../../homeStore/thankyou/videoModal";
import sajana from "../../../assets/images/sajana.png";
import personalInfoImg from "../../../assets/images/payment/1.gif";
import msgImg from "../../../assets/images/icons/msg-icon.webp";
import AudioPlayerComponent from "./AudioPlayerComponent";

interface GreetingsComponentInterface {
  data?: any;
}
const GreetingsComponent: React.FC<GreetingsComponentInterface> = (props) => {
  const { data } = props;
  const state = useAppSelector((state) => state);
  const { userData }: { userData?: any } = state.profile;

  return (
    <Card bordered={false} id="greeting-card">
      <h1 className="greeting-card-heading">
        Made this all for you, {getFirstName(userData?.name) ?? ""}!
      </h1>
      {/* <p className="greeting-card-feedback textarea-text">{data?.feedback}</p>
      <div className="greeting-card-footer">
        {data?.feedback ? <>-Sajana, Skincare Guide</> : <></>}
      </div> */}
      <div className="greeting-card-image">
        <img className="image" src={personalInfoImg} alt="img" />
        <p className="post">— Sajana, Licensed Esthetician</p>
        <AudioPlayerComponent file={data?.media_file} />
      </div>
      <div className="greeting-card-footer-msg">
        <div className="heading">
          <img className="image" src={msgImg} alt="img" height={30} width={30} />
          <h2 className="title">Missing Skincare Promise</h2>
        </div>
        <div className="msg-body">
          <div className="msg">This entire space is made with honest care for your skin and budget — no product pushes, no affiliates, no sponsors.</div>
        </div>
      </div>
    </Card>
  );
};

export default GreetingsComponent;
